import React, { Component } from 'react';
// import "./style.css";
import '../../Components/Navbar/navPlugin';
// Compontents
import PCover from '../../Components/PCover/PCover';
import AddProject from '../../Components/AddProject/AddProjects';
import Navbar from '../../Components/Navbar/Navbar';
import PCarouesl from '../../Components/ProjectCarousel/ProjectCarousel';
import Demo from '../../Components/Demo/Demo';
import Header from '../../Components/HeadText/Head';
import Skill from '../../Components/Skill/Skill';
import Download from '../../Components/DownloadApp/Download';
import Loading from '../../Components/loading/loading';
import DB from '../../Config/db';

import './pdStyle.css';
import Features from '../../Components/Features/Features';
import { logEventPage } from '../../Components/Firebase';

class ProjectDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      project: {
        name: '',
        cover: '',
        logo: 'https://firebasestorage.googleapis.com/v0/b/portfolio-789d4.appspot.com/o/images%2FPLanguages%2Fmk.jpg?alt=media&token=b6681d4f-ca19-49ef-9bc0-da88bed7d881',
        images: [],
        demoURL: '',
      },
      items: [
        { target: 'head', name: 'Head' },
        { target: 'features', name: 'Features' },
        // { target: 'demo', name: 'Demo' },
      ],
      loading: true,
    };

    // console.log("Project Data : ", this.props);
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    const project = DB.projects[id];
    logEventPage('Application Details', project.name);
    this.getData();
  }

  getData = () => {
    const { id } = this.props.match.params;
    const project = DB.projects[id];
    const oldItems = this.state.items;

    console.log('ID : ', DB.projects[id]);
    this.setState({
      project,
      loading: false,
      items: project.demoURL
        ? [...oldItems, { target: 'demo', name: 'Demo' }]
        : oldItems,
    });
    window.scrollTo(0, 0);
  };

  checkNavBarItems = () => {
    let i = this.state.items;
    let p = this.state.project;

    if (p.demoURL) {
      alert('d');
      i.push({ target: 'demo', name: 'Demo' });
    }
    if (p.techs) {
      i.push({ target: 'techs', name: 'Technologies' });
    }
    i.push({ target: 'try', name: 'Try' });
    this.setState({
      items: i,
    });
  };

  render() {
    const { project, items, loading } = this.state;
    if (loading) {
      return <Loading />;
    }

    return (
      <>
        <Navbar items={items || []} />
        <PCover project={project} />
        <Features project={project} />
        {project.demoURL ? <Demo demoUrl={project.demoURL} /> : null}
      </>
    );
  }
}

export default ProjectDetails;
